import { baseApi } from './baseApi';

const hospitalApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getHospital: builder.query({
        query: (hospital) => `api/v4/hospital?subdomain=${hospital}`,
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetHospitalQuery } = hospitalApi;
